export default [
  { "text": "阿尔巴尼亚", "value": 355 },
  { "text": "阿尔及利亚", "value": 213 },
  { "text": "阿富汗", "value": 93 },
  { "text": "阿根廷", "value": 54 },
  { "text": "阿拉伯联合酋长国", "value": 971 },
  { "text": "阿鲁巴", "value": 297 },
  { "text": "阿曼", "value": 968 },
  { "text": "阿塞拜疆", "value": 994 },
  { "text": "阿森松岛", "value": 247 },
  { "text": "埃及", "value": 20 },
  { "text": "埃塞俄比亚", "value": 251 },
  { "text": "爱尔兰", "value": 353 },
  { "text": "爱沙尼亚", "value": 372 },
  { "text": "安道尔", "value": 376 },
  { "text": "安哥拉", "value": 244 },
  { "text": "安圭拉", "value": 1264 },
  { "text": "安提瓜和巴布达", "value": 1268 },
  { "text": "奥地利", "value": 43 },
  { "text": "澳大利亚", "value": 61 },
  { "text": "巴巴多斯", "value": 1246 },
  { "text": "巴布亚新几内亚", "value": 675 },
  { "text": "巴哈马", "value": 1242 },
  { "text": "巴基斯坦", "value": 92 },
  { "text": "巴拉圭", "value": 595 },
  { "text": "巴勒斯坦", "value": 970 },
  { "text": "巴林", "value": 973 },
  { "text": "巴拿马", "value": 507 },
  { "text": "巴西", "value": 55 },
  { "text": "白俄罗斯", "value": 375 },
  { "text": "百慕大群岛", "value": 1441 },
  { "text": "保加利亚", "value": 359 },
  { "text": "北马利安纳群岛", "value": 1670 },
  { "text": "贝宁", "value": 229 },
  { "text": "比利时", "value": 32 },
  { "text": "冰岛", "value": 354 },
  { "text": "波多黎各", "value": 1787 },
  { "text": "波兰", "value": 48 },
  { "text": "波斯尼亚和黑塞哥维那", "value": 387 },
  { "text": "玻利维亚", "value": 591 },
  { "text": "伯利兹", "value": 501 },
  { "text": "博茨瓦纳", "value": 267 },
  { "text": "不丹", "value": 975 },
  { "text": "布基纳法索", "value": 226 },
  { "text": "布隆迪", "value": 257 },
  { "text": "赤道几内亚", "value": 240 },
  { "text": "丹麦", "value": 45 },
  { "text": "德国", "value": 49 },
  { "text": "东帝汶", "value": 670 },
  { "text": "多哥", "value": 228 },
  { "text": "多米尼加", "value": 1767 },
  { "text": "多米尼加共和国", "value": 1809 },
  { "text": "厄瓜多尔", "value": 593 },
  { "text": "厄立特里亚", "value": 291 },
  { "text": "法国", "value": 33 },
  { "text": "法罗群岛", "value": 298 },
  { "text": "法属波利尼西亚", "value": 689 },
  { "text": "法属圭亚那", "value": 594 },
  { "text": "菲律宾", "value": 63 },
  { "text": "斐济", "value": 679 },
  { "text": "芬兰", "value": 358 },
  { "text": "冈比亚", "value": 220 },
  { "text": "刚果共和国", "value": 242 },
  { "text": "刚果民主共和国", "value": 243 },
  { "text": "哥伦比亚", "value": 57 },
  { "text": "哥斯达黎加", "value": 506 },
  { "text": "格林纳达", "value": 1473 },
  { "text": "格陵兰岛", "value": 299 },
  { "text": "格鲁吉亚", "value": 995 },
  { "text": "瓜德罗普岛", "value": 590 },
  { "text": "瓜地马拉", "value": 502 },
  { "text": "关岛", "value": 1671 },
  { "text": "圭亚那", "value": 592 },
  { "text": "哈萨克斯坦", "value": 7 },
  { "text": "海地", "value": 509 },
  { "text": "韩国", "value": 82 },
  { "text": "荷兰", "value": 31 },
  { "text": "荷兰加勒比", "value": 599 },
  { "text": "荷属安的列斯", "value": 599 },
  { "text": "黑山", "value": 382 },
  { "text": "洪都拉斯", "value": 504 },
  { "text": "基里巴斯", "value": 686 },
  { "text": "吉布提", "value": 253 },
  { "text": "吉尔吉斯斯坦", "value": 996 },
  { "text": "几内亚", "value": 224 },
  { "text": "几内亚比绍共和国", "value": 245 },
  { "text": "加拿大", "value": 1 },
  { "text": "加纳", "value": 233 },
  { "text": "加蓬", "value": 241 },
  { "text": "柬埔寨", "value": 855 },
  { "text": "捷克", "value": 420 },
  { "text": "津巴布韦", "value": 263 },
  { "text": "喀麦隆", "value": 237 },
  { "text": "卡塔尔", "value": 974 },
  { "text": "开曼群岛", "value": 1345 },
  { "text": "开普", "value": 238 },
  { "text": "科摩罗", "value": 269 },
  { "text": "科索沃共和国", "value": 383 },
  { "text": "科威特", "value": 965 },
  { "text": "克罗地亚", "value": 385 },
  { "text": "肯尼亚", "value": 254 },
  { "text": "库克群岛", "value": 682 },
  { "text": "库拉索", "value": 599 },
  { "text": "拉脱维亚", "value": 371 },
  { "text": "莱索托", "value": 266 },
  { "text": "老挝", "value": 856 },
  { "text": "黎巴嫩", "value": 961 },
  { "text": "立陶宛", "value": 370 },
  { "text": "利比里亚", "value": 231 },
  { "text": "利比亚", "value": 218 },
  { "text": "列支敦士登", "value": 423 },
  { "text": "留尼汪", "value": 262 },
  { "text": "卢森堡", "value": 352 },
  { "text": "卢旺达", "value": 250 },
  { "text": "罗马尼亚", "value": 40 },
  { "text": "马达加斯加", "value": 261 },
  { "text": "马丁尼克", "value": 596 },
  { "text": "马尔代夫", "value": 960 },
  { "text": "马耳他", "value": 356 },
  { "text": "马拉维", "value": 265 },
  { "text": "马来西亚", "value": 60 },
  { "text": "马里", "value": 223 },
  { "text": "马其顿", "value": 389 },
  { "text": "马绍尔群岛", "value": 692 },
  { "text": "马约特", "value": 269 },
  { "text": "毛里求斯", "value": 230 },
  { "text": "毛里塔尼亚", "value": 222 },
  { "text": "美国", "value": 1 },
  { "text": "美属萨摩亚", "value": 1684 },
  { "text": "美属维尔京群岛", "value": 1340 },
  { "text": "蒙古", "value": 976 },
  { "text": "蒙特塞拉特岛", "value": 1664 },
  { "text": "孟加拉国", "value": 880 },
  { "text": "秘鲁", "value": 51 },
  { "text": "密克罗尼西亚", "value": 691 },
  { "text": "缅甸", "value": 95 },
  { "text": "摩尔多瓦", "value": 373 },
  { "text": "摩洛哥", "value": 212 },
  { "text": "摩纳哥", "value": 377 },
  { "text": "莫桑比克", "value": 258 },
  { "text": "墨西哥", "value": 52 },
  { "text": "拿鲁岛", "value": 674 },
  { "text": "纳米比亚", "value": 264 },
  { "text": "南非", "value": 27 },
  { "text": "南苏丹", "value": 211 },
  { "text": "尼加拉瓜", "value": 505 },
  { "text": "尼泊尔", "value": 977 },
  { "text": "尼日尔", "value": 227 },
  { "text": "尼日利亚", "value": 234 },
  { "text": "挪威", "value": 47 },
  { "text": "帕劳", "value": 680 },
  { "text": "葡萄牙", "value": 351 },
  { "text": "日本", "value": 81 },
  { "text": "瑞典", "value": 46 },
  { "text": "瑞士", "value": 41 },
  { "text": "萨尔瓦多", "value": 503 },
  { "text": "萨摩亚", "value": 685 },
  { "text": "塞尔维亚", "value": 381 },
  { "text": "塞拉利昂", "value": 232 },
  { "text": "塞内加尔", "value": 221 },
  { "text": "塞浦路斯", "value": 357 },
  { "text": "塞舌尔", "value": 248 },
  { "text": "沙特阿拉伯", "value": 966 },
  { "text": "圣彼埃尔和密克隆岛", "value": 508 },
  { "text": "圣多美和普林西比", "value": 239 },
  { "text": "圣基茨和尼维斯", "value": 1869 },
  { "text": "圣露西亚", "value": 1758 },
  { "text": "圣马力诺", "value": 378 },
  { "text": "圣文森特和格林纳丁斯", "value": 1784 },
  { "text": "斯里兰卡", "value": 94 },
  { "text": "斯洛伐克", "value": 421 },
  { "text": "斯洛文尼亚", "value": 386 },
  { "text": "斯威士兰", "value": 268 },
  { "text": "苏丹", "value": 249 },
  { "text": "苏里南", "value": 597 },
  { "text": "所罗门群岛", "value": 677 },
  { "text": "索马里", "value": 252 },
  { "text": "塔吉克斯坦", "value": 992 },
  { "text": "泰国", "value": 66 },
  { "text": "坦桑尼亚", "value": 255 },
  { "text": "汤加", "value": 676 },
  { "text": "特克斯和凯科斯群岛", "value": 1649 },
  { "text": "特立尼达和多巴哥", "value": 1868 },
  { "text": "突尼斯", "value": 216 },
  { "text": "土耳其", "value": 90 },
  { "text": "土库曼斯坦", "value": 993 },
  { "text": "瓦努阿图", "value": 678 },
  { "text": "委内瑞拉", "value": 58 },
  { "text": "文莱", "value": 673 },
  { "text": "乌干达", "value": 256 },
  { "text": "乌克兰", "value": 380 },
  { "text": "乌拉圭", "value": 598 },
  { "text": "乌兹别克斯坦", "value": 998 },
  { "text": "西班牙", "value": 34 },
  { "text": "西撒哈拉", "value": 212 },
  { "text": "希腊", "value": 30 },
  { "text": "象牙海岸", "value": 225 },
  { "text": "新加坡", "value": 65 },
  { "text": "新喀里多尼亚", "value": 687 },
  { "text": "新西兰", "value": 64 },
  { "text": "匈牙利", "value": 36 },
  { "text": "牙买加", "value": 1876 },
  { "text": "亚美尼亚", "value": 374 },
  { "text": "也门", "value": 967 },
  { "text": "伊拉克", "value": 964 },
  { "text": "以色列", "value": 972 },
  { "text": "意大利", "value": 39 },
  { "text": "印度", "value": 91 },
  { "text": "印度尼西亚", "value": 62 },
  { "text": "英国", "value": 44 },
  { "text": "英属处女群岛", "value": 1284 },
  { "text": "英属圣马丁", "value": 1721 },
  { "text": "约旦", "value": 962 },
  { "text": "越南", "value": 84 },
  { "text": "赞比亚", "value": 260 },
  { "text": "乍得", "value": 235 },
  { "text": "直布罗陀", "value": 350 },
  { "text": "智利", "value": 56 },
  { "text": "中非共和国", "value": 236 },
  { "text": "中国澳门", "value": 853 },
  { "text": "中国台湾", "value": 886 },
  { "text": "中国香港", "value": 852 },
  { "text": "中国大陆", "value": 86 }
]


//////////////////
// WEBPACK FOOTER
// ./static/js/areaCode.js
// module id = null
// module chunks = 